var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentInstance,{key:_vm.company.id,tag:"component",attrs:{"profilfarbe":_vm.ProfilFarbe,"profildark":_vm.ProfilDark,"profilfarbenstyle":_vm.ProfilFarbenStyle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }